<div [formGroup]="previsaoGroup">
    <div class="row pt-2 pb-1 pr-2">

        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Previsão para Pagamento</mat-label>
                <input matInput [matDatepicker]="pickerPrev" formControlName="datetimePrevisao" (input)="onDateInput($event)">
                <mat-datepicker-toggle matIconSuffix [for]="pickerPrev"></mat-datepicker-toggle>
                <mat-datepicker #pickerPrev></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="col-12 col-md-2 text-danger">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Juros Previsto</mat-label>
                <input matInput formControlName="valorJuros" [currencyMask]="currencyMask">
                <mat-icon matSuffix class="text-danger">trending_up</mat-icon>
            </mat-form-field>
        </div>

        <div class="col-12 col-md-2 text-danger">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Multa Prevista</mat-label>
                <input matInput formControlName="valorMulta" [currencyMask]="currencyMask">
                <mat-icon matSuffix class="text-danger">gavel</mat-icon>
            </mat-form-field>
        </div>

        <div class="col-12 col-md-2 text-danger">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Acréscimo Previsto</mat-label>
                <input matInput formControlName="valorAcrescimo" [currencyMask]="currencyMask">
                <mat-icon matSuffix class="text-danger">add_circle_outline</mat-icon>
            </mat-form-field>
        </div>

        <div class="col-12 col-md-2 text-success">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Desconto Previsto</mat-label>
                <input matInput formControlName="valorDesconto" [currencyMask]="currencyMask">
                <mat-icon matSuffix class="text-success">trending_down</mat-icon>
            </mat-form-field>
        </div>

    </div>
</div>